module.exports = __webpack_public_path__ + "files/a105c8ff3a093225242531eb31dacd8d.png";